// Storefront platform set: the six brands the category bar, the mobile drawer,
// the footer and the home page show. Kinguin splits each brand into several
// `platform` values ("Xbox One", "Xbox Series X|S", "GOG.com"), so every entry
// lists the exact facet values (`GET /products/filters`) it stands for and
// links to all of them as one multi-select. One list, one place.
import steam from '../assets/home/plat-steam.svg';
import playstation from '../assets/home/plat-playstation.svg';
import xbox from '../assets/home/plat-xbox.svg';
import nintendo from '../assets/home/plat-nintendo.svg';
import epic from '../assets/home/plat-epic.svg';
import gog from '../assets/home/plat-gog.svg';

export interface Platform {
  name: string;
  icon: string;
  /** Exact backend `platform` values grouped under this brand. */
  facets: readonly string[];
}

export const PLATFORMS: readonly Platform[] = [
  { name: 'Steam', icon: steam, facets: ['Steam'] },
  { name: 'PlayStation', icon: playstation, facets: ['PlayStation', 'PlayStation 5', 'PlayStation 4', 'PlayStation 3'] },
  { name: 'Xbox', icon: xbox, facets: ['Xbox Series X|S', 'Xbox One', 'Xbox 360'] },
  { name: 'Nintendo', icon: nintendo, facets: ['Nintendo', 'Nintendo Switch 2', 'Nintendo Switch'] },
  { name: 'Epic Games', icon: epic, facets: ['Epic Games'] },
  { name: 'GOG', icon: gog, facets: ['GOG.com'] },
];

/** Catalog link selecting every given `platform` value (sidebar multi-select). */
export function platformLink(facets: readonly string[]): string {
  return `/catalog?platforms=${encodeURIComponent(facets.join(','))}`;
}

/** Sum of the facet counts a brand groups; facets missing from `counts` add 0. */
export function platformCount(platform: Platform, counts: Record<string, number>): number {
  return platform.facets.reduce((sum, f) => sum + (counts[f] ?? 0), 0);
}
